// export type DRAGGABLE_TYPE_PAGE = 'DRAGGABLE_TYPE_PAGE'
// export type DRAGGABLE_TYPE_BLOCK = 'DRAGGABLE_TYPE_BLOCK'
// export type DRAGGABLE_TYPE_SYMBOL = 'DRAGGABLE_TYPE_SYMBOL'

// export type DRAGGABLE_TYPE =
//   | DRAGGABLE_TYPE_PAGE
//   | DRAGGABLE_TYPE_BLOCK
//   | DRAGGABLE_TYPE_SYMBOL

export enum DRAGGABLE_TYPE {
  PAGE = 'node',
  BLOCK = 'block',
  SYMBOL = 'symbol',
}

export enum DROPZONE_TYPE {
  PAGE = 'dropzone_node',
  PAGE_NEXT = 'dropzone_node_next',
  BLOCK = 'dropzone_block',
  SYMBOL = 'dropzone_symbol',
}

export type COORDINATES = {
  x: number
  y: number
}
